import { axiosInstance } from 'src/boot/axios';
import { formatDateWithoutTime } from 'src/utils/format';

const DATE_FORMAT = 'yyyy-MM-dd';

export function saveGeneralPractitionerRequest({ commit }, payload) {
  const formData = new FormData();

  payload.selectedCustomerNumbers.forEach((x) => {
    formData.append('CurrentSelectedCustomerNumbers', x);
  });
  formData.set('Reason', payload.reason.key);
  formData.set('CurrentGeneralPractitioner.Name', payload.currentGp.name);
  formData.set('CurrentGeneralPractitioner.City', payload.currentGp.city);
  formData.set('NewCustomerAddressKnown', payload.address.isKnown.key === 'yes');
  if (payload.address.isKnown.key === 'no') {
    formData.set('NewCustomerPostalCode', payload.address.postalCode);
  }

  commit('setIsSavingCareMediation', true);

  return axiosInstance.post('CareMediation/GeneralPractitioner', formData).finally(() => {
    commit('setIsSavingCareMediation', false);
  });
}

export function saveMaternityCareRequest({ commit }, payload) {
  const formData = new FormData();

  formData.set('CurrentSelectedCustomerNumber', payload.selectedCustomerNumber);
  formData.set('AlreadyContacted', payload.alreadyContacted.key === 'yes');
  formData.set('IsSignedUp', payload.alreadySignedUp.isSignedUp.key === 'yes');
  if (payload.alreadySignedUp.isSignedUp.key === 'yes') {
    formData.set('Reason', payload.alreadySignedUp.reason);
  }
  formData.set('DueDate', formatDateWithoutTime(payload.when, DATE_FORMAT));
  if (payload.alreadySignedUp.isSignedUp.key === 'no') {
    formData.set('Confirmation', payload.alreadySignedUp.confirmation?.key === 'yes');
  }

  if (payload.additionalInformation) {
    formData.set('AdditionalInformation', payload.additionalInformation);
  }

  commit('setIsSavingCareMediation', true);

  return axiosInstance.post('CareMediation/MaternityCare', formData).finally(() => {
    commit('setIsSavingCareMediation', false);
  });
}

export function saveDistrictCareRequest({ commit }, payload) {
  const formData = new FormData();

  formData.set('CurrentSelectedCustomerNumber', payload.selectedCustomerNumber);
  formData.set('Topic', payload.topic.key);
  formData.set('Indication', payload.indication.key);
  formData.set('Type', payload.type.key);
  formData.set('AmountOfCareKnown', payload.time.known.key === 'yes');
  if (payload.type.key !== 2 && payload.time.known.key === 'yes') {
    formData.set('NursingTime.Hours', payload.type.key !== 2 ? (payload.time.nursing.hours ?? 0) : 0);
    formData.set('NursingTime.Minutes', payload.type.key !== 2 ? (payload.time.nursing.minutes ?? 0) : 0);
  }
  if (payload.type.key !== 1 && payload.time.known.key === 'yes') {
    formData.set('PersonalCareTime.Hours', payload.type.key !== 1 ? (payload.time.personalCare.hours ?? 0) : 0);
    formData.set('PersonalCareTime.Minutes', payload.type.key !== 1 ? (payload.time.personalCare.minutes ?? 0) : 0);
  }

  formData.set('AlreadySignedUp', payload.alreadySignedUp.isSignedUp.key === 'yes');

  if (payload.alreadySignedUp.isSignedUp.key === 'yes') {
    formData.set('DistrictCare.City', payload.alreadySignedUp.city);
    formData.set('DistrictCare.Name', payload.alreadySignedUp.name);
    formData.set('HealthcareMediationInformation', payload.healthcareMediationInformation);
  }

  if (payload.additionalInformation) {
    formData.set('AdditionalInformation', payload.additionalInformation);
  }

  commit('setIsSavingCareMediation', true);

  return axiosInstance.post('CareMediation/DistrictCare', formData).finally(() => {
    commit('setIsSavingCareMediation', false);
  });
}

export function saveMentalHealthCareRequest({ commit }, payload) {
  const formData = new FormData();

  formData.set('Reference', payload.reference.key);
  if (payload.reference.name === 'other') {
    formData.set('OtherReferenceText', payload.referenceFreeText);
  }
  formData.set('ReferenceDate', payload.referenceDate);
  formData.set('KindOfMentalHealthCare', payload.kindOfMentalHealthCare.key);
  formData.set('DiagnoseTreatment', payload.isDiagnosis.key);
  formData.set('Stay', payload.stay.key === 'yes');
  formData.set('MentalHealthCareTopic', payload.topic.key);
  if (payload.topic.name === 'other') {
    formData.set('OtherTopicText', payload.topicFreeText);
  }
  formData.set('TreatmentFormKnown', payload.treatmentFormKnown.key === 'yes');
  if (payload.treatmentFormKnown.key === 'yes') {
    formData.set('TreatmentForm', payload.treatmentForm.key ?? 0);
  }
  if (payload.treatmentFormKnown.key === 'yes' && payload.treatmentForm.name === 'other') {
    formData.set('OtherTreatmentFormText', payload.treatmentFormFreeText);
  }
  formData.set('OnWaitingList', payload.waitingList.onWaitingList.key === 'yes');
  if (payload.waitingList.onWaitingList.key === 'yes') {
    formData.set('HealthCareInstance.Name', payload.waitingList.name);
    formData.set('HealthCareInstance.City', payload.waitingList.city);
    formData.set('WaitingTimeKnown', payload.waitingList.waitingTimeKnown?.key === 'yes');
  }

  if (payload.waitingList.onWaitingList.key === 'yes' && payload.waitingList.waitingTimeKnown?.key === 'yes') {
    formData.set('WaitingTime', `${payload.waitingList.time.amount}  ${payload.waitingList.time.indication.value}`);
  }
  formData.set('Distance', payload.distance.key);
  formData.set('SickLeave.IsSickLeave', payload.sickLeave.isSickLeave.key === 'yes');
  if (payload.sickLeave.isSickLeave.key === 'yes') {
    formData.set(
      'SickLeave.SickDate',
      payload.sickLeave.date ? formatDateWithoutTime(payload.sickLeave.date, DATE_FORMAT) : null,
    );
  }
  if (payload.additionalInformation) {
    formData.set('AdditionalInformation', payload.additionalInformation);
  }

  commit('setIsSavingCareMediation', true);

  return axiosInstance.post('CareMediation/MentalHealthCare', formData).finally(() => {
    commit('setIsSavingCareMediation', false);
  });
}

export function saveMedicalSpecialistRequest({ commit }, payload) {
  const formData = new FormData();

  formData.set('SelectedCustomerNumber', payload.selectedCustomerNumber);
  formData.set('CareType', payload.type.key);
  if (payload.type.name === 'neuroscience') {
    formData.set('AdditionalInfoNeuroscienceText', payload.additionalInfoNeuroscience);
  }
  formData.set('Topic', payload.partData.part.key);
  if (payload.partData.part.name === 'second-opinion') {
    formData.set('SpecialistConsulted', payload.partData.specialistConsulted?.key === 'yes');
  }
  if (payload.partData.part.name === 'research') {
    formData.set('Research', payload.partData.researchType?.key ?? 0);
  }
  if (payload.partData.part.name === 'surgery') {
    formData.set('OperationTopicText', payload.partData.surgeryDescription);
  }
  if (payload.partData.part.name === 'research' && payload.partData.researchType?.name === 'other') {
    formData.set('OtherResearchText', payload.partData.researchTypeFreeForm);
  }
  if (payload.partData.part.name === 'research' && payload.partData.researchType?.name === 'mri') {
    formData.set('MriOptions', payload.partData.requestor?.key ?? 0);
  }
  if (payload.partData.part.name === 'research' && payload.partData.researchType?.name === 'scopy') {
    formData.set('ScopyResearchText', payload.partData.scopy);
  }
  formData.set('MediationType', payload.mediationData.mediationType.key);
  if (payload.mediationData.mediationType.name === 'waiting-list') {
    formData.set('AlreadyOnWaitingList', payload.mediationData.alreadySignedUp?.key === 'yes');
  }
  if (payload.mediationData.alreadySignedUp?.key === 'yes') {
    formData.set('HealthCareInstance.Name', payload.mediationData.business.name);
    formData.set('HealthCareInstance.City', payload.mediationData.business.city);
    formData.set('PractitionerName', payload.mediationData.practitioner);
    formData.set('WaitingTime', `${payload.mediationData.time.amount}  ${payload.mediationData.time.indication.value}`);
  }
  formData.set('Distance', payload.distance.key);
  formData.set('SickLeave.IsSickLeave', payload.sickLeave.isSickLeave.key === 'yes');
  if (payload.sickLeave.isSickLeave.key === 'yes') {
    formData.set('SickLeave.SickDate', payload.sickLeave.date ? payload.sickLeave.date : null);
  }

  if (payload.additionalInformation) {
    formData.set('AdditionalInformation', payload.additionalInformation);
  }

  if (payload.selectAdditionalInfo?.isSelectAdditionalInfo?.key === 'yes') {
    payload.selectAdditionalInfo?.selectAdditionalInformation?.forEach((x) => {
      formData.append('AdditionalOptions', x.key);
    });
  }

  commit('setIsSavingCareMediation', true);

  return axiosInstance.post('CareMediation/MedicalSpecialist', formData).finally(() => {
    commit('setIsSavingCareMediation', false);
  });
}
